import React from 'react';
import configureStore from './configureStore';
import {Provider} from "react-redux";
import RouterContainer from './RouterContainer';

const store = configureStore();

export default () => {
  
  return (
    <Provider store={store}>
      <RouterContainer />
    </Provider>
  );
  
}